import table from './table';
import { transform } from './transform';

const name = 'staffFMCSASubmissionsQueue';
const path = 'student_infos/new_fmcsa_queue_report';

export default {
  table,
  get: {
    name,
    path,
    transform,
    defaultValue: []
  }
};
